import React, { Component } from 'react'
import ApiHelper from "services/api-helper"
import { Button, Form, Select, Modal, Input, Checkbox, Message } from "semantic-ui-react"
import toastr from 'toastr'

export default class QuanLyUserTaoMoi extends Component {
  state = {
    webGroupList: [],
    obj: {
      IdNhanVien: null,
      UserName: '',
      Password: '',
      WebGroupId: null,
      HoatDong: true
    },
    boPhanList: [],
    boPhanSelected: null,
    nhanVienList: [],
    existUsername: false,
    invalidNhanVien: false,
    invalidUserName: false,
    formError: false,
    submit: false
  }
  componentDidMount() {
    this.getWebGroupList()
    this.getDanhSachBoPhan()
  }
  getWebGroupList = () => {
    ApiHelper.GetJson('api/getWebGroupList').then(res => {
      if (res.length > 0)
        this.setState({ webGroupList: res, obj: { ...this.state.obj, WebGroupId: res[0].Oid } })
    }, error => {
      toastr.error(error)
    })
  }
  getDanhSachBoPhan = () => {
    ApiHelper.GetJson('api/getDanhSachBoPhanByUser').then(res => {
      if (res.length > 1) res.unshift({ Oid: null, TenBoPhan: 'Tất cả' })
      if (res.length > 0)
        this.setState({ boPhanList: res, boPhanSelected: res[0].Oid })
      this.getDanhSachNhanVien()
    }, error => {
      toastr.error(error)
    })
  }
  getDanhSachNhanVien = () => {
    ApiHelper.GetJson('api/getDanhSachNhanVien', { BoPhanId: this.state.boPhanSelected }).then(res => {
      if (res.length > 0) {
        this.setState({ nhanVienList: res })
        if (res.findIndex(q => q.Oid === this.state.obj.IdNhanVien) === -1) {
          this.setState({ obj: { ...this.state.obj, IdNhanVien: null } })
        }
      }
    }, error => {
      toastr.error(error)
    })
  }
  taoUser = () => {
    var error = false;
    this.setState({ submit: true })
    if (!this.state.obj.IdNhanVien && this.state.obj.WebGroupId !== '00000000-0000-0000-0000-000000000001') {
      this.setState({ invalidNhanVien: true })
      error = true
    }

    if (this.state.existUsername || this.state.obj.UserName === '') {
      this.setState({ invalidUserName: true })
      error = true
    }

    if (error) {
      this.setState({ formError: true })
      return
    }
    else this.setState({ formError: false })

    ApiHelper.PostJson('api/User/Insert', this.state.obj).then((res) => {
      if (res === 2) {
        toastr.error('Trùng tên tài khoản')
      }
      else {
        toastr.success('Thành công!')
        this.props.closeModal()
      }
    }, error => {
      toastr.error(error)
    })
  }
  checkExistUsername = async (userName) => {
    return await ApiHelper.GetJson('api/User/CheckExistUsername', {
      Username: userName
    })
  }
  handleWebGroup = (e, { value }) => {
    this.setState({ obj: { ...this.state.obj, WebGroupId: value } })
  }
  handleBoPhan = (e, { value }) => {
    this.setState({ boPhanSelected: value })
    setTimeout(() => {
      this.getDanhSachNhanVien()
    })
  }
  handleNhanVien = (e, { value }) => {
    this.setState({ obj: { ...this.state.obj, IdNhanVien: value } })
  }
  handleUserName = (e, { value }) => {
    this.setState({ existUsername: null })
    this.setState({ obj: { ...this.state.obj, UserName: value } })
    this.checkExistUsername(value).then(res => {
      if (res) {
        this.setState({ existUsername: true })
        this.setState({ formError: true })
      } else {
        this.setState({ existUsername: false })
      }
    })
  }
  handlePassword = (e, { value }) => {
    this.setState({ obj: { ...this.state.obj, Password: value } })
  }
  handleHoatDong = (e, { value }) => {
    this.setState({ obj: { ...this.state.obj, HoatDong: !this.state.obj.HoatDong } })
  }
  render() {
    const webGroupList = this.state.webGroupList.map(item => {
      return { value: item.Oid, text: item.Name }
    })
    const boPhanList = this.state.boPhanList.map(item => {
      return { value: item.Oid, text: item.TenBoPhan }
    })
    const nhanVienList = this.state.nhanVienList.map(item => {
      return { value: item.Oid, text: item.HoTen }
    })
    return (
      <Modal
        open={this.props.openModal}
        onClose={this.props.closeModal}
      >
        <Modal.Header>Tạo tài khoản</Modal.Header>
        <Modal.Content>
          <Form error={this.state.formError}>
            <Form.Field control={Select} options={webGroupList} label="Loại tài khoản"
              value={this.state.obj.WebGroupId}
              onChange={this.handleWebGroup}
            />
            <Form.Field control={Select} options={boPhanList} label="Bộ phận"
              placeholder={boPhanList.map(q => q.text)[0]}
              value={this.state.boPhanSelected}
              onChange={this.handleBoPhan}
            />
            <Form.Field control={Select} options={nhanVienList} label="Nhân viên"
              placeholder="Chọn nhân viên" search
              value={this.state.obj.IdNhanVien}
              onChange={this.handleNhanVien}
              error={this.state.invalidNhanVien}
            />
            <Form.Group widths='equal'>
              <Form.Field required={true} error={this.state.existUsername || this.state.invalidUserName}>
                <Input label="Username"
                  value={this.state.obj.UserName}
                  onChange={this.handleUserName}
                  loading={this.state.existUsername === null}
                />
                {this.state.existUsername && <Message error content={"Trùng tên tài khoản"} />}
                {this.state.submit && this.state.obj.UserName === ''
                  && <Message error content={"Vui lòng nhập username"} />}
              </Form.Field>
              <Form.Field>
                <Input label="Password" type="password"
                  value={this.state.obj.Password}
                  onChange={this.handlePassword}
                />
              </Form.Field>
            </Form.Group>
            <Form.Field>
              <Checkbox toggle label="Hoạt động" onChange={this.handleHoatDong}
                checked={this.state.obj.HoatDong}
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.props.closeModal} negative>
            Hủy
          </Button>
          <Button
            onClick={this.taoUser}
            positive
            labelPosition='left'
            icon='checkmark'
            content='Lưu'
          />
        </Modal.Actions>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/quan-ly-users/tao-moi-modal.jsx